module.exports = __webpack_public_path__ + "img/logo@2x.5af3a564.png";